import React, { useEffect, useState } from 'react'
import {
    BarcodeScanner,
    BarcodeFormat,
    LensFacing,
} from '@capacitor-mlkit/barcode-scanning';
// import { Torch } from '@capawesome/capacitor-torch';
import { useNavigate } from 'react-router-dom';
import { BiQrScan } from "react-icons/bi";
import useQRScanner from '../useQRScanner';
import { useToast } from '../../components/controls/Toast/ToastService';
import { MdErrorOutline } from 'react-icons/md';

export default function QRScanner({ setOpen }) {
    const [barcodeResult, setBarcodeResult] = useState()
    const { startScanQr, endScanQr } = useQRScanner()
    const toast = useToast()
    const startScan = async () => {
        // The camera is visible behind the WebView, so that you can customize the UI in the WebView.
        // However, this means that you have to hide all elements that should not be visible.
        // You can find an example in our demo repository.
        // In this case we set a class `barcode-scanner-active`, which then contains certain CSS rules for our app.
        startScanQr()
        document.querySelector('body')?.classList.add('barcode-scanner-active');

        // Add the `barcodeScanned` listener
        const listener = await BarcodeScanner.addListener(
            'barcodeScanned',
            async result => {
                //alert(JSON.stringify(result.barcode))
                console.log(result.barcode);
                setBarcodeResult(result.barcode?.displayValue)
                endScanQr()
            },
        );

        // Start the barcode scanner
        await BarcodeScanner.startScan();
    };

    const stopScan = async () => {
        // Make all elements in the WebView visible again
        document.querySelector('body')?.classList.remove('barcode-scanner-active');

        // Remove all listeners
        await BarcodeScanner.removeAllListeners();

        // Stop the barcode scanner
        await BarcodeScanner.stopScan();
    };

    const scanSingleBarcode = async () => {
        return new Promise(async resolve => {
            document.querySelector('body')?.classList.add('barcode-scanner-active');

            const listener = await BarcodeScanner.addListener(
                'barcodeScanned',
                async result => {
                    await listener.remove();
                    document
                        .querySelector('body')
                        ?.classList.remove('barcode-scanner-active');
                    await BarcodeScanner.stopScan();
                    resolve(result.barcode);
                },
            );

            await BarcodeScanner.startScan();
        });
    };

    const scan = async () => {
        const { barcodes } = await BarcodeScanner.scan({
            formats: [BarcodeFormat.QrCode],
        });
        return barcodes;
    };

    const isSupported = async () => {
        const { supported } = await BarcodeScanner.isSupported();
        return supported;
    };

    // const enableTorch = async () => {
    //     await Torch.enable();
    // };

    // const disableTorch = async () => {
    //     await Torch.disable();
    // };

    // const toggleTorch = async () => {
    //     await Torch.toggle();
    // };

    // const isTorchEnabled = async () => {
    //     const { enabled } = await Torch.isEnabled();
    //     return enabled;
    // };

    // const isTorchAvailable = async () => {
    //     const { available } = await Torch.isAvailable();
    //     return available;
    // };

    const setZoomRatio = async () => {
        await BarcodeScanner.setZoomRatio({ zoomRatio: 0.5 });
    };

    const getZoomRatio = async () => {
        const { zoomRatio } = await BarcodeScanner.getZoomRatio();
        return zoomRatio;
    };

    const getMinZoomRatio = async () => {
        const { zoomRatio } = await BarcodeScanner.getMinZoomRatio();
        return zoomRatio;
    };

    const getMaxZoomRatio = async () => {
        const { zoomRatio } = await BarcodeScanner.getMaxZoomRatio();
        return zoomRatio;
    };

    const openSettings = async () => {
        await BarcodeScanner.openSettings();
    };

    const isGoogleBarcodeScannerModuleAvailable = async () => {
        const { available } =
            await BarcodeScanner.isGoogleBarcodeScannerModuleAvailable();
        return available;
    };

    const installGoogleBarcodeScannerModule = async () => {
        await BarcodeScanner.installGoogleBarcodeScannerModule();
    };

    //'prompt' | 'prompt-with-rationale' | 'granted' | 'denied'
    const checkPermissions = async () => {
        const { camera } = await BarcodeScanner.checkPermissions();
        return camera;
    };

    const requestPermissions = async () => {
        const { camera } = await BarcodeScanner.requestPermissions();
        return camera;
    };

    const navigate = useNavigate()

    useEffect(() => {
        checkPermissions().then(res => {
            if (res != 'granted') {
                requestPermissions().then(reqRes => {
                    if (reqRes == 'denied') {
                        navigate(-1)
                    }
                })
            }
        })
        return () => {
            stopScan()
        }
    }, [])

    const afterSacning = () => {
        stopScan()
        try {
            let r = barcodeResult.split('doctor/')
            if (r[1]) {
                navigate("/doctor/" + r[1])
            }
            else {
                toast.open("It is not a Doctora QR Code, Please scan valid QR.", <MdErrorOutline />, "danger", 5000)
            }
        } catch (err) {
            toast.open("It is not a Doctora QR Code, Please scan valid QR.", <MdErrorOutline />, "danger", 5000)
        }
    }

    useEffect(() => {
        if (barcodeResult) {
            endScanQr()
            afterSacning()
        }
    }, [barcodeResult])

    const scanAndstop = () => {
        startScan()
        setOpen(false)
    }
    return (
        <button onClick={scanAndstop} className="transition-all duration-300 flex gap-2 item-center justify-center">
            <span className='my-auto shadow-2xl px-3 py-1 bg-orange-400 hover:bg-orange-500 text-white rounded-lg'>
                Scan doctor's QR
            </span>
            <div className='bg-orange-400 hover:bg-orange-500 text-white p-4 rounded-full shadow-2xl '>
                <BiQrScan size={20} />
            </div>
        </button>
    )
}
